/*
 * @Author: cc
 */
import { useEffect, useState, useRef } from 'react'
import useStore from '../../store/useStore'

import VditorPreview from "vditor";

const MarkdownMsg = ({ content, id }: { content: string, id: string }) => {
    const [columns, setColumns] = useState<any>([]);
    const { store, dispatch } = useStore();

    let memos: any = []

    useEffect(() => {
        let _content: any = ''
        // console.log('VditorPreview', content)
        if (content.indexOf('来源->便签Id集合->') > -1) {
            _content = content.slice(0, content.indexOf('来源->便签Id集合->'))
            _content = _content + '<br/><br/> 来源->便签Id集合->'
            let Id_Arr: any = content.slice(content.indexOf('来源->便签Id集合->') + 13, content.length)
            Id_Arr = Id_Arr.split(',');
            memos = []
            Id_Arr.map((item: any) => {
                if (item.length > 1) {
                    memos.push(<div onClick={() => {
                        clickExpend(item);
                    }} className='ant-btn mb-10  mr-10 ant-btn-sm'>{item}</div>)
                }
            })
            setColumns(memos)
            console.log('VditorPreview1', Id_Arr, Id_Arr.length, _content)
        } else {
            _content = content
            setColumns([])
        }
        VditorPreview.preview((document as any).querySelector(`.vditor_${id}`), _content, { mode: 'light', cdn: "https://static.move2newidea.com/vditor/3.9.7" })
    }, [content])
    const clickExpend = (item: any,) => {
        let _id = item.slice(0, 17)
        let cur_memo = store.subjectInfo.data.memos.find((item: any) => item.id == _id)
        dispatch({
            type: 'SET_PING_MEMO',
            data: {
                data: cur_memo
            }
        });
    }
    return (
        <>
            {/* <>{content}</>--- */}
            <div id="vditor1" className={`vditor_${id}`} />
            <div data-flex='main:left flex-wrap'>
                {columns}
            </div>
        </>
    );
};

export default MarkdownMsg;
